// In-app privacy policy viewer. Replaces window.open('/privacy.html','_blank'),
// which on Android TWA / iOS WKWebView opens an external surface with no in-app
// way back. Here we render privacy.html inside an iframe in our own #overlay,
// with a sticky header + ✕ Close button, and wire the device Back button to it.
import i18next from 'i18next';
import * as overlay from './overlay';

let popHandler: ((e: PopStateEvent) => void) | null = null;

export function openPrivacy(): void {
  const title = i18next.t('menu.privacy');

  overlay.show(`
    <div style="position:absolute;inset:0;display:flex;flex-direction:column;background:#0b0d10;
                padding-top:env(safe-area-inset-top);">
      <div style="flex:0 0 auto;display:flex;align-items:center;justify-content:space-between;
                  padding:12px 16px;background:#1a1f25;border-bottom:1px solid #3a3f47;
                  font-family:system-ui,-apple-system,'Segoe UI',Roboto,sans-serif;">
        <span style="color:#e8edf2;font-size:18px;font-weight:600;">${title}</span>
        <button id="privacy-close" aria-label="Close"
                style="appearance:none;border:none;background:#243240;color:#7ec4ff;
                       font-size:22px;line-height:1;cursor:pointer;border-radius:8px;
                       width:44px;height:44px;display:flex;align-items:center;justify-content:center;">✕</button>
      </div>
      <iframe src="/privacy.html" title="${title}"
              style="flex:1 1 auto;width:100%;border:none;background:#0b0d10;"></iframe>
    </div>
  `);

  // Hardware/gesture Back closes the overlay instead of leaving the app.
  history.pushState({ privacy: true }, '');
  popHandler = () => close({ fromPop: true });
  window.addEventListener('popstate', popHandler);

  const btn = document.getElementById('privacy-close');
  btn?.addEventListener('click', () => close({ fromPop: false }));
}

// fromPop: the close was triggered by a popstate (Back) — history already moved,
// so we must NOT call history.back() again. Otherwise pop our pushed entry.
function close({ fromPop }: { fromPop: boolean }): void {
  if (popHandler) {
    window.removeEventListener('popstate', popHandler);
    popHandler = null;
  }
  overlay.hide();
  if (!fromPop && history.state?.privacy) history.back();
}
